import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
  borderBottom: (theme) => `0.1rem solid ${theme.palette.divider}`,
}

export const contentGridSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    lg: '112rem',
    xl: '152rem',
  },
  margin: 'auto',
  columnGap: '4.8rem',
  alignItems: 'center',
  padding: {
    lg: '4rem 0',
    md: '3.2rem 5.7rem',
    xs: '2.4rem',
  },
}

export const percentItemsTextSx: SxProps<Theme> = {
  marginTop: '1.6rem',
  marginLeft: '1.5rem',
}

export const accordionSx: SxProps<Theme> = {
  '&.MuiAccordion-root:first-of-type': {
    borderTopLeftRadius: '0.8rem',
    borderTopRightRadius: '0.8rem',
  },
  '&.MuiAccordion-root:last-of-type': {
    borderBottomLeftRadius: '0.8rem',
    borderBottomRightRadius: '0.8rem',
  },
}
